/*
 * localStorage key name for persistent video play volume on a domain.
 */
export const VG_VOLUME_KEY: string = 'videogularVolume';
